export default __webpack_public_path__ + "static/media/header-onboarding-2.8aa74f04.svg";